export default 'https://sielx3mxb9.execute-api.eu-west-1.amazonaws.com';
